import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import styled from "styled-components";
import Loading from "../sharable/Loading";
import { useSearchParams } from "react-router-dom";
import Logo from "../sharable/Logo";
import Notification from "../sharable/Notification";
import Help from "../sharable/Help";
const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
const Container = styled.div`
  gap: 3rem;
  padding-bottom: 3rem;
  position: relative;
  width: 100vw;
  overflow-y: scroll;

  header {
    padding: 2rem 4.2rem;
  }
  nav {
    font-size: 1.6rem;
    width: 100%;
    justify-content: center;

    gap: 3rem;
    span {
      cursor: pointer;
      transition: color ease-in-out 200ms;
      &:hover {
        color: #d97706;
      }
    }
  }
  .nav {
    align-self: center !important;
  }
`;

const Title = styled.h1`
  text-align: center;
  font-size: 2.4rem;
`;

const Description = styled.p`
  text-align: center;
  font-size: 1.4rem;
  span {
    color: #d97706;
  }
`;
const API_KEY = process.env.REACT_APP_STRIPE_KEY;
const stripe = loadStripe(API_KEY);

//COMPONENT VERIFIED 31/05;
export default function CreditCardCheckout() {
  const { token, activeAccount, accountStatus } = useOutletContext();
  const [clientSecret, setClientSecret] = useState();
  let [params] = useSearchParams();
  const navigate = useNavigate();

  const [resStatus, setResStatus] = useState();

  const loadCheckoutSession = useEffect(() => {
    const load = async () => {
      const plan = params.get("lookup_key");
      if (!plan) return navigate("/planos");
      const url = `${BASE_URL}subscription/checkout-session`;
      const res = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ plan: plan }),
      });
      setResStatus(res.status);
      if (res.ok) {
        console.log("Response is ok ");
        const s = await res.text();
        setClientSecret(s);
      } else {
        setClientSecret("");
      }
    };
    load();
  }, [token, activeAccount]);
  return (
    <Container className="flex direction-column">
      <header className="flex align">
        <Logo showGoBackButton={true} path={"/planos"} />
        <nav className="flex">
          <span onClick={() => navigate("/planos")}>Ver planos</span>
          <span onClick={() => navigate("/encartes")}>Página inicial</span>
        </nav>
      </header>
      {resStatus === 429 && (
        <Notification
          message="Limite de requisições atingido. Tente novamente mais tarde."
          type="error"
          autoHide={true}
          duration={4000}
        />
      )}
      {accountStatus.autoRenewalOn ? (
        <>
          <p
            style={{
              textAlign: "center",
              padding: "0 2rem",
              fontSize: "1.4rem",
              marginTop: "4.8rem  ",
            }}
          >
            Não é possível assinar um novo plano possuindo uma assinatura ativa.
            Cancela para poder alterar o seu plano.
          </p>
          <Notification
            message={"Você já possui uma assinatura ativa."}
            type="info"
          />
        </>
      ) : (!accountStatus.autoRenewalOn && clientSecret && stripe) ||
        resStatus != undefined ? (
        <>
          <div>
            <Title>Assinatura</Title>
            <Description>
              Com o <span>OfertasExpress</span> você consegue expor suas ofertas
              de forma rápida e atrair mais clientes para o seu negócio
            </Description>
          </div>
          <div id="checkout">
            <EmbeddedCheckoutProvider
              stripe={stripe}
              options={{
                clientSecret: clientSecret,
                onComplete: () => navigate("/formulario"),
              }}
            >
              <EmbeddedCheckout className="checkout" />
            </EmbeddedCheckoutProvider>
          </div>
        </>
      ) : (
        <Loading />
      )}
      <Help />
    </Container>
  );
}
